/* unplugin-vue-components disabled */import script from "./ExpForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpForm.vue?vue&type=script&lang=ts&setup=true"

import "./ExpForm.vue?vue&type=style&index=0&id=1cea838d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cea838d"]])

export default __exports__